import { Inject, Optional, Pipe, PipeTransform } from "@angular/core";
import {
  defaultPlaceholder,
  NO_VALUE_PLACEHOLDER
} from "./no-value-placeholder";

@Pipe({
    name: "noValue",
    standalone: false
})
export class NoValuePipe implements PipeTransform {
  constructor(
    @Inject(NO_VALUE_PLACEHOLDER)
    @Optional()
    private readonly placeholder: string | null
  ) {
    if (this.placeholder == null) {
      this.placeholder = defaultPlaceholder;
    }
  }

  transform(value: any, placeholder?: string): any {
    if (value == null || value.length === 0 || Number.isNaN(value)) {
      return placeholder != null ? placeholder : this.placeholder;
    }
    return value;
  }
}
